import { AxiosError } from 'axios';

import { CreateLeadFinancialApiPayload } from '@/actions/leads/createLeadFinancial';
import { GetLeadFinancialApiResponse } from '@/actions/leads/getLeadFinancial';
import { ZEE_FINANCIAL_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';

export const updateLeadFinancial = async (
  payload: Omit<CreateLeadFinancialApiPayload, 'zee_id'>
): Promise<ApiResponse<GetLeadFinancialApiResponse>> => {
  try {
    const response = await apiManager.put(`${ZEE_FINANCIAL_API_URL}`, payload, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
